
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29","cy":"29","r":"27.5","stroke":"#161F32","stroke-width":"3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.759 18.601c-.64 0-1.16.522-1.16 1.165V30.43H39.4V19.766c0-.643-.52-1.165-1.16-1.165H19.76zm19.999 13.524H20.912h-2.67l-2.006 3.493h25.528l-2.006-3.493zm2.598 5.188c-.046 1.1-.934 2.086-2.163 2.086H17.807c-1.228 0-2.117-.987-2.163-2.086h26.712zm-24.549 3.78c-2.963 0-4.815-3.22-3.334-5.798l2.438-4.244V19.766c0-1.58 1.275-2.86 2.848-2.86H38.24a2.854 2.854 0 012.848 2.86v11.285l2.438 4.244c1.48 2.577-.371 5.799-3.334 5.799H17.807z","fill":"#202D38"}})])
          )
        }
      }
    